SharedMdl.directive('scrollToFans', [ '$transitions', function($transitions){
	return {
		restrict: 'A',
		link: function( scope, element, attrs ){
			//$transitions.onStart({}, function ( transition ) {
			//	//console.log(transition.params('to', 'from'))
			//	if ( transition.$to().name === 'main.categories.families.colors' || transition.$to().name === 'main.categories.families.effects.colors' ) {
			//		if( ( transition.params().color_fan_slug && transition.params().effect_fan_slug ) || transition.params().color_fan_slug ){
			//
			//		}
			//	}
			//})
		}

	}

}]);
